export class AppSettings {
    public static USER_INFO = 'user-info';
    public static SYNUID = 'synuid';
    public static USER_ID = 'user-id';
    public static PRODUCT_INFO = 'product-info';

    public static Status_Draft= 1;
    public static Status_Submit= 2;
    public static Status_Approve= 3;
    public static Status_Reject= 4;
    public static Status_Inprogress = 5;

    public static ASMROLE_ID = '1';
    public static TSMROLE_ID = '2';
    public static ADMIN_ID = '3';
    public static CALENDAR_DAYS= '14';
    public static BACK_DAYS= '2';
    public static EDITABLE_BACK_DAYS='2';
    public static EDITABLE_BACK_DAYS_FOR_MONDAY='2'

    public static SORT_ORDER_ASC = '0';
    public static SORT_ORDER_DESC = '1';

    public static SORT_ORDER_ASC_Indent = 0;
    public static SORT_ORDER_DESC_Indent = 1;

    public static CALLED_FROM_INDENT = "called_from_indent";
    public static AppMenu = 'Indent';
   
   

    public static base64Header = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
    
    public static USER_LANG = 'en';
    public static CHANNEL_F = 'F';
    public static CHANNEL_N = 'N';
    public static MAX_Approve_Limit = 10;
    public static DGAPP = 'DG';
    public static SPSAPP = 'SPS';
    public static IndentAPP = 'Indent';

    public static AppVersion="v2.0.0.1";
    

    //public static SAP_URL = " https://syngentaapitest.apimanagement.hana.ondemand.com:443/REST/SalesOrder";
   
 }